import React from "react";
import { Spinner } from "react-bootstrap";

export const CommonSpinner = () => {
  return <Spinner animation="border" variant="primary" />;
};
